import $ from "/home/wpsoup6/domains/tijdschriftenplaza.nl/public_html/wp-content/plugins/wp-soup-framework/node_modules/jquery";
import "./ads";

function equalheight(container) {

  var currentTallest = 0,
    currentRowStart = 0,
    rowDivs = new Array(),
    $el,
    topPosition = 0;
  $(container).each(function () {
    $el = $(this);
    $($el).height("auto");
    topPosition = $el.position().top;

    if (currentRowStart != topPosition) {
      for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPosition;
      currentTallest = $el.height();
      rowDivs.push($el);
      // console.log(rowDivs);
    } else {
      rowDivs.push($el);
      currentTallest =
        currentTallest < $el.height() ? $el.height() : currentTallest;
    }
    for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
}

$(window).load(function () {
  let screenSize = $(window).width();
  $('.ms_subscriptions-multiple, .ms_subscriptions-separate').each(function(){
    const mostPopular = $(this).find(".most-popular-text");
    const title       = $(this).find(".title-container");
    const label       = $(this).find(".label-container");
    const detail      = $(this).find(".details");
    const img         = $(this).find(".img-container");
    const description = $(this).find(".general-description");
    const price       = $(this).find(".price-container");
    const order       = $(this).find(".order-container");

    if (screenSize > 500) {
      equalheight(mostPopular);
      equalheight(title);
      equalheight(label);
      equalheight(detail);
      equalheight(img);
      equalheight(description);
      equalheight(price);
      equalheight(order);
    }
  });
  window.dispatchEvent(new Event('resize'));
});

$(window).resize(function () {


  let screenSize = $(window).width();
  $('.ms_subscriptions-multiple, .ms_subscriptions-separate').each(function(){
    const mostPopular = $(this).find(".most-popular-text");
    const title       = $(this).find(".title-container");
    const label       = $(this).find(".label-container");
    const detail      = $(this).find(".details");
    const img         = $(this).find(".img-container");
    const description = $(this).find(".general-description");
    const price       = $(this).find(".price-container");
    const order       = $(this).find(".order-container");

    if (screenSize > 500) {
      equalheight(mostPopular);
      equalheight(title);
      equalheight(label);
      equalheight(detail);
      equalheight(img);
      equalheight(description);
      equalheight(price);
      equalheight(order);
    }
  });
});
